import React from "react";
import { useTranslation } from "react-i18next";
import Link from "../../../../utils/Link";

export default function BottomHeader({}) {
  const { t } = useTranslation();

  const data = [
    {
      text: t("pages.branches.label"),
      icon: "i-location-point",
      link: "/branches",
    },
    {
      text: t("buttonMenus.myFibank"),
      icon: "i-monitor",
      link: "https://e-banking.fibank.al/",
    },
  ];

  return (
    <div className="header-bottom">
      <div className="wrapper header-bottom__wrapper">
        <ul className="header-bottom__list">
          {data.map(({ icon, text, link }) => (
            <li className="header-bottom__list-item" key={text}>
              {link.startsWith("http") ? (
                <a href={link}>
                  <i className={icon} />
                  {t(text)}
                </a>
              ) : (
                <Link to={link}> {t(text)}</Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
